module.exports = __webpack_public_path__ + "img/ksyun.8be35b20.jpg";